/**
 * The "Evo" pill on an event gap strip (2026-10-20 owner ask): the Dex's Evo
 * toggle, for the Profile's Quick update card and Catch radar rows and the
 * Calendar's event cards. On, every species an event features brings its
 * whole evolution line to the strip (lib/eventEvoLines), so a line is one
 * commit; off, the strip shows what the event lists.
 *
 * One device-wide switch behind every copy of this pill (lib/evoLinesPref),
 * so flipping it on the Profile flips it on the Calendar too. Same look as
 * the Dex pill and the Wild Area card's Ticket switch.
 */
import { Dna } from "lucide-react";
import { useEvoLines } from "@/lib/evoLinesPref";

export function EvoLinesToggle({ testId }: { testId: string }) {
  const [on, setOn] = useEvoLines();
  return (
    <button
      type="button"
      onClick={() => setOn(!on)}
      aria-pressed={on}
      aria-label={on ? "Whole evolution lines on. Tap for the event's own list" : "Add each species' whole evolution line"}
      title="Whole evolution lines on these tiles"
      data-testid={testId}
      className="inline-flex items-center gap-1 rounded-full px-2.5 text-[10px] font-extrabold shrink-0"
      style={{
        minHeight: 30,
        background: on ? "var(--accent-fill-glow-faint)" : "var(--surface-sunken)",
        border: `1px solid ${on ? "var(--accent-fill-glow)" : "var(--border-subtle)"}`,
        color: on ? "var(--text-primary)" : "var(--text-secondary)",
      }}
    >
      <Dna className="w-3 h-3" aria-hidden />
      Evo
    </button>
  );
}
